import React from 'react';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Heading5 } from '~/components/atom/Typography';
import RadioButton from '~/components/molecule/RadioButton';

const text = {
  yes: 'Ja',
  no: 'Nee',
  didAppointmentHappen: 'Heeft de afspraak plaatsgevonden?',
};

type Props = {
  hasAppointmentHappened: boolean;
  toggleAppointmentHappened: (value: boolean) => void;
};

const DidAppointmentHappen: React.FCC<Props> = ({
  hasAppointmentHappened,
  toggleAppointmentHappened,
}) => (
  <JustificationContainer direction="column" margin={[null, null, 'm', null]}>
    <Heading5 required>{text.didAppointmentHappen}</Heading5>
    <JustificationContainer gap="s" align="center">
      <RadioButton
        label={text.yes}
        checked={hasAppointmentHappened}
        onChange={() => toggleAppointmentHappened(true)}
      />
      <RadioButton
        label={text.no}
        checked={!hasAppointmentHappened}
        onChange={() => toggleAppointmentHappened(false)}
      />
    </JustificationContainer>
  </JustificationContainer>
);

export default DidAppointmentHappen;
